import styled from "@emotion/styled";
import { css } from "@styled-system/css";
import React from "react";

type Props = {
  children: React.ReactNode;
};

const Root = styled("div")(({ theme }) =>
  css({
    position: "relative",
    overflow: "auto",
    margin: "0 auto",
    height: "100vh",
    WebkitOverflowScrolling: "touch",
    [`@media ${theme.mediaQueries.tablet}`]: {
      maxWidth: "100vw",
    },
    [`@media ${theme.mediaQueries.landscape}`]: {
      maxWidth: "100vw",
    },
    [`@media ${theme.mediaQueries.portrait}`]: {
      maxWidth: "100vw",
      height: "100%",
    },
  }),
);

export const SharedAppShell: React.VFC<Props> = (props) => {
  return <Root>{props.children}</Root>;
};
